import List from 'antd/es/list';

export default List;
